module.exports = __webpack_public_path__ + "static/img/spray--02_2x.8c25991.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/spray--02_2x.png
// module id = O/re
// module chunks = 1